export const faqsPl = [
  {
    q: "Co obejmuje backend i panel administracyjny?",
    a: "Zazwyczaj API pod aplikację mobilną lub webową, panel admina (użytkownicy, role, treści, dashboard), integracje zewnętrzne i infrastrukturę. Najczęściej budujemy to jako jeden projekt z aplikacją — nie jako trzy osobne zlecenia.",
  },
  {
    q: "Czy możecie przejąć istniejący backend (Node.js, Java)?",
    a: "Tak. Częsta ścieżka: NDA, audyt repozytorium, modernizacja legacy, migracja do chmury i dalsze utrzymanie. Dostajesz ocenę długu technicznego i plan dalszego developmentu.",
  },
  {
    q: "Ile kosztuje panel administracyjny do aplikacji?",
    a: "Prosty panel (CRUD, role, podstawowy dashboard) w ramach MVP to zwykle część wyceny całej aplikacji. Samodzielny panel z integracjami i raportami to najczęściej dziesiątki–setki tysięcy zł — zależnie od skali. Dajemy orientacyjną wycenę po rozmowie o zakresie.",
  },
  {
    q: "Jakie technologie backendowe stosujecie?",
    a: "Najczęściej Node.js / TypeScript, PostgreSQL, REST lub GraphQL, AWS albo infrastruktura w UE. Dobieramy stack do Waszego zespołu i wymagań — nie narzucamy technologii dla samego narzucania.",
  },
  {
    q: "Czy budujecie integracje API (CRM, płatności, ERP)?",
    a: "Tak. Często łączymy Stripe, BLIK, Przelewy24, CRM, TMS, Shoper, Enova i inne systemy. Integracje planujemy w zakresie MVP albo jako osobny etap po podstawowym panelu.",
  },
  {
    q: "Czy oferujecie utrzymanie backendu ze SLA?",
    a: "Tak — monitoring, alerty, poprawki, dyżury i model godzinowy albo abonament. Firmy często szukają partnera do utrzymania po wdrożeniu albo po odejściu poprzedniego wykonawcy.",
  },
  {
    q: "Czy panel admina może być częścią MVP?",
    a: "Tak — i zwykle powinien. Logowanie, role, dashboard i powiadomienia to rdzeń wielu pierwszych wydań. Budujemy panel równolegle z aplikacją użytkownika.",
  },
  {
    q: "Czy możecie zacząć od audytu kodu pod NDA?",
    a: "Tak. NDA przed dostępem do repozytorium to standard. Po audycie dostajesz raport, ryzyka i wycenę dalszej współpracy.",
  },
] as const;
